import React from "react";
import Seo from "../components/Seo";

export default function Privacy() {
  return (
    <div className="min-h-screen max-w-4xl mx-auto px-6 lg:px-10 py-16 text-[#F5F0E6]" data-testid="privacy-page">
      <Seo
        title="Privacy & Website Analytics"
        description="How Beyond Board Woodworking handles quote requests, contact messages and limited website analytics."
        path="/privacy"
      />
      <p className="text-xs uppercase tracking-[0.25em] text-[#26C6D5]">Website information</p>
      <h1 className="font-display text-4xl sm:text-5xl mt-4">Privacy &amp; Analytics</h1>
      <div className="mt-8 space-y-8 text-[#B8B7B2] leading-relaxed">
        <section>
          <h2 className="font-display text-2xl text-[#F5F0E6] mb-2">Quote and contact requests</h2>
          <p>When you submit a quote or message, we use the details you provide to reply,
             prepare your custom order and manage the request. These records are separate
             from anonymous website analytics. Do not include payment card information or
             passwords in free-text messages.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-[#F5F0E6] mb-2">Website analytics</h2>
          <p>We use PostHog on public pages to understand page visits and whether a quote
             request or contact message was successfully submitted. The analytics setup
             does not send the contents of forms, your name, email, message, or
             customization details as event properties. Automatic click and form
             capture and session replay are disabled. PostHog may still process
             technical browser and session identifiers needed for analytics.</p>
          <p className="mt-3">Visits, quote requests and paid orders are different
             measurements. Analytics events alone do not establish that someone
             became a customer or that payment was received.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-[#F5F0E6] mb-2">Services and questions</h2>
          <p>Our website hosting, email delivery and analytics providers process
             information needed to provide their services. You can adjust browser
             tracking and cookie controls. For questions about your information,
             contact <a className="underline text-[#8FE8F8]" href="mailto:beyondboardwoodwork@gmail.com">beyondboardwoodwork@gmail.com</a>.</p>
        </section>
      </div>
    </div>
  );
}
